import { useQuery } from '@tanstack/react-query';
import { jiraApi } from '../api/jira';

// Dashboard summary refreshes every 30s to feel "live" without overwhelming Jira -
// matches the server-side cache TTL so polling never fetches stale-but-uncached data.
export function useJiraSummary() {
  return useQuery({
    queryKey: ['jira', 'summary'],
    queryFn: jiraApi.getSummary,
    refetchInterval: 30_000,
    staleTime: 15_000,
    retry: false,
  });
}

export function useJiraProjects() {
  return useQuery({
    queryKey: ['jira', 'projects'],
    queryFn: jiraApi.getProjects,
    refetchInterval: 60_000,
  });
}

export function useJiraIssueTypes() {
  return useQuery({
    queryKey: ['jira', 'issue-types'],
    queryFn: jiraApi.getIssueTypes,
    staleTime: 10 * 60_000,
  });
}

export function useJiraIssues(params: {
  projectKey?: string;
  status?: string;
  issueType?: string;
  query?: string;
  maxResults?: number;
}) {
  return useQuery({
    queryKey: ['jira', 'issues', params],
    queryFn: () => jiraApi.getIssues(params),
    refetchInterval: 30_000,
  });
}